import React from 'react';
import {
  Affix,
  Button, Dropdown, Layout, Menu,
} from 'antd';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser,
} from '@fortawesome/pro-light-svg-icons';
import { useDispatch } from 'react-redux';
import { Box, Text } from '../../shared/components';
import UserInfo from '../components/UserInfo.datadisplay';
import TwoColumnsFlexLayout from '../../shared/components/layout/TwoColumnsFlex.layout';
import LanguageSelector from './LanguageSelector.dataentry';
import Flex from '../../shared/components/basic/Flex';
import SearchBar from './searchBar';
import HideOnScroll from '../../shared/components/dataDisplay/HideOnScroll';
import { setPageNavigationIsHidden } from '../../../state/actions/creators/app.actioncreator';
import {MIN_WIDTH} from "../../../state/actions/constants/app.constants";

const { Header } = Layout;

export default function AppHeader({ history }) {
  const dispatch = useDispatch();
  return (
    <Box style={{ position: 'sticky', top: '0', zIndex: 1000, minWidth: MIN_WIDTH}}>
      <Header style={{ padding: 0 }}>
        <TwoColumnsFlexLayout
          flexLeft={1}
          leftContent={<SearchBar />}
          rightContent={(
            <Box style={{ textAlign: 'right' }} className="headerMenuRightBar">
              <Box style={{ height: '64px' }} display="inline-block">
                <LanguageSelector />
              </Box>
              <Dropdown
                overlay={(
                  <Menu>
                    <Menu.Item>
                      <NavLink to="/logout">
                        <Text translationId="app.cerrar_sesion" />
                      </NavLink>
                    </Menu.Item>
                  </Menu>
              )}
              >
                <Flex alignItems="center" justifyContent="flex-end" style={{ float: 'right' }} pr="24" width="450px">
                  <UserInfo />
                  <Box ml="24px">
                    <div className="barAvatarCircle">
                      <FontAwesomeIcon icon={faUser} fontSize={16} />
                    </div>
                  </Box>
                </Flex>
              </Dropdown>

            </Box>
        )}
        />
      </Header>
      <HideOnScroll hide onHideChange={(hidden, hiddenHeight) => dispatch(setPageNavigationIsHidden(hidden, hiddenHeight))} target="scrollableDiv">
        <TwoColumnsFlexLayout
          bg="#DDE5F2"
          p="16"
          flexLeft={3}
          style={{ height: '48px' }}
          leftContent={(
            <Flex>
              {
                <Button type="link" onClick={() => history.push('/encargos/crear')}><Text>Nuevo encargo</Text></Button>
              // <Button type="link" onClick={() => history.push('/encargos/2965/tienda/0/mostrar')}><Text>Mostrar encargo</Text></Button>
              // <Button type="link" onClick={() => history.push('/encargos/2964/tienda/0/mostrar')}><Text>Mostrar encargo</Text></Button>
              // <Button type="link" onClick={() => history.push('/catalogosPropios')}><Text>Catalogos Propios</Text></Button>
            }
            </Flex>
        )}
          rightContent={(<div>&nbsp;</div>)}
        />
      </HideOnScroll>
    </Box>
  );
}
